import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5503cb6d&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CasesLoop: require('/Volumes/DEV/Bitbucket/garden-eight-v3/nuxt/components/cases/loop.vue').default,LayoutSitemap: require('/Volumes/DEV/Bitbucket/garden-eight-v3/nuxt/components/layout/sitemap.vue').default})
